import React, { useState } from 'react';
import { useMutation } from 'react-apollo';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import { GoogleLogin } from 'react-google-login';
import { useSelector } from 'react-redux';
import { API } from 'aws-amplify';
import useSnack from 'hooks/useSnack';
import Loading from 'components/common/Spin';
import { UPDATE_REFERRAL } from 'graphql/referral';

const SyncContacts = ({ referral, onConnected }) => {
  const user = useSelector((s) => s.user.user);
  const snack = useSnack();
  const [updateReferral] = useMutation(UPDATE_REFERRAL);
  const [saving, setSaving] = useState(false);

  const onAuthError = (resp) => {
    console.log(resp);
    snack.error(resp.error);
  };

  const onSuccess = ({ code }) => {
    setSaving(true);
    return API.post('api', '/users/exchange-google-code', { body: { code } })
      .then((resp) =>
        updateReferral({
          variables: {
            id: referral.id,
            data: {
              google_tokens: resp,
            },
          },
        }),
      )
      .then((resp) => {
        snack.success('Success! Google account connected.');
        onConnected();
      })
      .catch((error) => {
        snack.error(error.message);
      })
      .finally(() => setSaving(false));
  };

  return (
    <Card component={Box} p={5} mb={3}>
      <Typography gutterBottom variant="h5">
        Sync Contacts
      </Typography>
      <Typography color="textSecondary">
        Sync your contacts to invite your friends to WeAdmit.
      </Typography>
      <Loading spinning={saving} linear={false}>
        <Box mt={3}>
          <GoogleLogin
            clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}
            buttonText="Sync Google Contacts"
            onSuccess={onSuccess}
            loginHint={user.email}
            onFailure={onAuthError}
            cookiePolicy={'single_host_origin'}
            scope="https://www.googleapis.com/auth/contacts.readonly https://www.googleapis.com/auth/contacts.other.readonly"
            responseType="code"
            accessType="offline"
            prompt="consent"
            redirectUri="postmessage"
          />
        </Box>
      </Loading>
    </Card>
  );
};

export default SyncContacts;
